import React from 'react';
import { Panel, Status } from './ApplicantHeader';

const show = (v) => (Array.isArray(v) ? (v.length ? v.join(', ') : '—') : (v === '' || v == null ? '—' : String(v)));

export default function ApplicantAnswers({ a }) {
  const answers = a.answers || {};
  const steps = (a.funnel || []).slice(0, 5);
  const levels = answers.languageLevels || {};
  return (
    <div className="space-y-4">
      <Panel title="Submission status" testId="submission-status">
        <dl className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-xs">
          <div><dt className="text-zinc-500">Receipt email</dt><dd className="font-medium" data-testid="status-receipt"><Status s={a.receipt_email} /></dd></div>
          <div><dt className="text-zinc-500">Staff notification</dt><dd className="font-medium" data-testid="status-notification"><Status s={a.staff_notification} /></dd></div>
          <div><dt className="text-zinc-500">Review task</dt><dd className="font-medium" data-testid="status-task"><Status s={a.review_task} /></dd></div>
        </dl>
        {a.resume_error && <p className="text-xs text-red-700">{a.resume_error}</p>}
        {a.resume && <p className="text-xs text-zinc-600">Résumé on file: {a.resume.filename} ({Math.round(a.resume.size / 1024)} KB) — private, staff download only.</p>}
        {a.source_channel === 'manual' && <p className="text-xs text-zinc-500">Manually added inquiry — the full questionnaire was not completed online.</p>}
      </Panel>
      {steps.map((s) => {
        const fields = s.fields.filter((f) => f.kind !== 'file' && Object.prototype.hasOwnProperty.call(answers, f.name)).filter((f) => {
          if (!f.condition) return true;
          const v = answers[f.condition[0]];
          return Array.isArray(v) ? v.some((x) => f.condition[1].includes(x)) : f.condition[1].includes(v);
        });
        if (!fields.length) return null;
        return (
          <Panel key={s.title} title={s.title} testId={`answers-${s.title.toLowerCase().replace(/[^a-z]+/g, '-')}`}>
            <dl className="space-y-3">
              {fields.map((f) => (
                <div key={f.name}>
                  <dt className="text-[11px] uppercase tracking-wide text-zinc-500">{f.label}</dt>
                  <dd className="text-sm text-zinc-900 whitespace-pre-wrap" data-testid={`answer-${f.name}`}>{show(answers[f.name])}</dd>
                  {f.name === 'languages' && Object.keys(levels).length > 0 && (
                    <dd className="text-xs text-zinc-600 mt-1">{Object.entries(levels).map(([l, lv]) => `${l}: ${lv}`).join(' · ')}</dd>
                  )}
                </div>
              ))}
            </dl>
          </Panel>
        );
      })}
    </div>
  );
}
